<div class="w-full h-full px-5 py-3 flex flex-col justify-between">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'settings.first.content.upload.title' | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>
  <div class="flex gap-5">
    <div
      xemexFilesDrop
      [acceptedTypes]="acceptedTypes"
      (dropped)="onFileDrop($event)"
      class="w-1/2 border-2 border-dashed border-primary pt-16 pb-8 px-4 rounded-3xl flex flex-col items-center"
    >
      <mat-icon class="text-primary text-[124px] !h-[124px] !w-[124px] mb-3">cloud_upload</mat-icon>
      <div class="text-xl text-primary mb-2">
        {{ 'creation.step1.dragAndDrop' | translate }}
      </div>
      <div class="text-xl text-primary">
        {{ 'creation.step1.or' | translate }}
      </div>
      <xemex-text-button type="button" class="mb-10" (click)="fileSelect.click()">
        {{ 'creation.step1.browserUpload' | translate }}
      </xemex-text-button>
      <div class="text-body font-light text-primary text-center">
        {{ 'creation.step1.messUpload' | translate }}
      </div>
      <input
        type="file"
        autocomplete="off"
        #fileSelect
        [hidden]="true"
        [accept]="acceptedTypes"
        xemexBrowseFile
        (fileSelected)="onFileSelected($event)"
        multiple
      />
    </div>
    <div class="w-1/2">
      <div class="flex rounded-lg bg-[#F5F5FA]/40 p-4 mb-4">
        <div class="w-3/5 text-xs font-semibold text-neutral">
          {{ 'settings.first.content.upload.fileName' | translate }}
        </div>
        <div class="w-2/5 text-xs font-semibold text-neutral">
          {{ 'settings.first.content.upload.status' | translate }}
        </div>
      </div>
      @for (item of shipmentStore.shipmentFileUpload(); let index = $index; track $index) {
        <div class="flex gap-4 px-4 py-1">
          <div class="w-3/5 text-body font-light">{{ item.file.name }}</div>
          @switch (item.status) {
            @case (UploadingStatus.Loading) {
              <div class="w-2/5 flex items-center justify-between gap-x-1">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <button
                  mat-icon-button
                  type="button"
                  class="!flex items-center justify-center !h-6 !w-6 !p-0"
                  (click)="onCancelUpload(index)"
                >
                  <mat-icon class="text-[1rem] !w-4 !h-4 text-primary">close</mat-icon>
                </button>
              </div>
            }
            @case (UploadingStatus.Failed) {
              <div class="w-2/5 flex items-center justify-between gap-x-1">
                <span class="font-light text-body text-crimson">{{
                  'general.failed' | translate
                }}</span>
                <button
                  mat-icon-button
                  type="button"
                  class="!flex items-center justify-center !h-6 !w-6 !p-0"
                  (click)="onRefreshUpload(index)"
                >
                  <mat-icon class="text-[1rem] !w-4 !h-4 text-crimson">refresh</mat-icon>
                </button>
              </div>
            }
            @default {
              <div class="w-2/5 flex items-center justify-between gap-x-1">
                <span class="2/5 font-light text-body text-primary">{{
                  'general.successful' | translate
                }}</span>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
  <div>
    <xemex-filled-button class="float-right" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</div>
